<template>
  <div class="main-container">
    <Experience
      class="resume-container"
      :userInfo="userInfo"
      :newList1='newList1'
      :newList2='newList2'
      :newList3='newList3'
      :newList4='newList4'
      :newList5='newList5'
      :newList6='newList6'
    ></Experience>
    <!-- <Win title="获奖情况" :win="winList" v-if="winList.length > 0"></Win> -->
  </div>
</template>

<script>
// import Win from "../components/Win.vue";
import Experience from "../components/Experience.vue";
export default {
  components: {
    // Win,
    Experience,
  },
  data() {
    return {
      winList: [],
      userInfo: {},
      newList1: {}, //教育背景
      newList2: {}, //工作经历
      newList3: {}, //职称经历
      newList4: {}, //社会任职
      newList5: {}, //获奖情况
      newList6: {}, //个人简介
    };
  },
  created() {
    // this.bjDetailList({
    //   userId: this.$route.query.id,
    // });
    let {id} = this.$route.query
    this.spaceScholarProfile(id)
    this.spaceScholarEduExp(id)
    this.spaceScholarWorkExp(id)
    this.spaceScholarTitleExp(id)
    this.spaceScholarPrize(id)
    this.spaceScholarMoonExp(id)
  },
  methods: {
    // 获取个人简介
    async spaceScholarProfile(userId){
      let res = await this.$apis.userServe.spaceScholarProfile({userId});
      console.log('个人简历',res)
      if(res.resultCode == 200){
        this.newList6 = res
      }
    },
    // 获取教育背景
    async spaceScholarEduExp(userId){
        let res = await this.$apis.userServe.spaceScholarEduExp({userId});
        console.log('教育背景',res)
        if(res.resultCode == 200){
          this.newList1 = res
        }
    },
    // 获取工作经历
    async spaceScholarWorkExp(userId){
        let res = await this.$apis.userServe.spaceScholarWorkExp({userId});
        console.log('工作经历',res)
        if(res.resultCode == 200){
          this.newList2 = res
        }
    },
    // 获取职称经历
    async spaceScholarTitleExp(userId){
        let res = await this.$apis.userServe.spaceScholarTitleExp({userId});
        console.log('职称经历',res)
        if(res.resultCode == 200){
          this.newList3 = res
        }
    },
    // 获取社会任职
    async spaceScholarMoonExp(userId){
        let res = await this.$apis.userServe.spaceScholarMoonExp({userId});
        console.log('社会任职',res)
        if(res.resultCode == 200){
          this.newList4 = res
        }
    },
    // 获取获奖情况
    async spaceScholarPrize(userId){
        let res = await this.$apis.userServe.spaceScholarPrize({userId});
        console.log('获奖情况',res)
        if(res.resultCode == 200){
          this.newList5 = res
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  .resume-container {
    background-color: #fff;
    margin-bottom: 16px;
  }
}
</style>
